<template>
  <div class="aftersale-detail">
    <div class="">
      <el-page-header @back="goBack" content="详情页面"></el-page-header>
    </div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>买家信息</span>
      </div>
      <div class="text item">
        <ul>
          <li class="mgb15">账号ID/微信名称：23423423</li>
          <li class="mgb15">手机号码：17828282822</li>
          <li class="mgb15">商品名称：谢谢谢谢谢谢</li>
          <li class="mgb15">子订单号：123243567854</li>
          <li>下单时间：2021-04-27 17:11:11</li>
          <!-- <li>换货地址：姓名/手机号/详细地址</li> -->
        </ul>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>换货人信息</span>
      </div>
      <div class="text item">
        <ul>
          <li class="mgb15">
            <span>换货人姓名：换货</span>
            <span>换货人电话：换货</span>
          </li>
          <li class="mgb15">换货地址：17828282822</li>
        </ul>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>申请信息</span>
      </div>
      <div class="text item">
        <ul>
          <li class="mgb15">售后类型：23423423</li>
          <li class="mgb15">购买数量：17828282822</li>
          <li class="mgb15">实付金额：谢谢谢谢谢谢</li>
          <!-- 退款 -->
          <li class="mgb15">
            <span class="mgr40">申请退款数量：22</span>
            <span class="mgr40">申请退款金额：￥22</span>
            <span>退款状态：￥22</span>
          </li>
          <!-- 退货 -->
          <li class="mgb15">
            <span class="mgr40">申请退货数量：22</span>
            <span class="mgr40">申请退货金额：￥22</span>
            <span>退款状态：￥22</span>
          </li>
        </ul>
      </div>
    </el-card>
    <el-card>
      <!-- 退货 -->
      <div>
        <el-table border>
          <el-table-column label="售后单号" align="center"></el-table-column>
          <el-table-column label="供应商名称" align="center"></el-table-column>
          <el-table-column label="所需退货数量" align="center"></el-table-column>
          <el-table-column label="所需退货金额" align="center"></el-table-column>
          <el-table-column label="退回状态" align="center"></el-table-column>
          <el-table-column label="确认退回" align="center"></el-table-column>
        </el-table>
      </div>
      <div>
        <el-card>
          <div>换货物流信息</div>
          <div>采购供应商：换句话菊花</div>
          <div>换货数量：66</div>
          <div>
            <el-button size="mini" type="primary">发货</el-button>
            <el-button size="mini" type="primary">更新物流</el-button>
            <el-button size="mini" type="primary">物流记录</el-button>
          </div>
        </el-card>
      </div>
      <div>
        <div class="">备注</div>
        <el-input type="textarea"></el-input>
      </div>
      <div class="btn-box">
        <el-button type="primary">保存</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  OrderAfterSaleGetAll
} from '../../api/api'
export default {

}
</script>

<style scoped>
.aftersale-detail{
  padding: 0 20px;
}
.box-card{
  margin-bottom: 20px;
}
.clearfix{
  font-size: 16px;
  font-weight: 700;
}
.mgb15{
  margin-bottom: 15px;
}
.mgr40{
  margin-right: 40px;
}
.total-box{
  margin-top: 15px;
  text-align: right;
}
.btn-box{
  /* text-align: center; */
  margin-top: 20px;
}
</style>